"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var PostTabsContext_1 = require("../../../../contexts/PostTabsContext");
var schemaSlice_1 = require("../../../../features/post/schemaSlice");
var PostSectionTypes_1 = require("../../../../constants/PostSectionTypes");
var PostViewContentTypes_1 = require("../../../../constants/PostViewContentTypes");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var FormStepsItem = react_1.memo(function (_a) {
    var idx = _a.idx, tab = _a.tab;
    var changedPostSchemaItems = react_1.useContext(PostTabsContext_1.PostTabsContext).changedPostSchemaItems;
    var t = react_i18next_1.useTranslation('common').t;
    var currentPropertyData = react_redux_1.useSelector(schemaSlice_1.selectCurrentPropertyType);
    var tabularTabRef = react_1.useRef(null);
    var _b = react_1.useContext(PostTabsContext_1.PostTabsContext), handleItemPositionChange = _b.handleItemPositionChange, postTabs = _b.postTabs, handleGoalChange = _b.handleGoalChange;
    react_1.useEffect(function () {
        if (tabularTabRef.current) {
            handleItemPositionChange(tab.name, tabularTabRef.current.offsetTop +
                tabularTabRef.current.offsetHeight / 2);
        }
    }, [tabularTabRef.current]);
    var isVisible = react_1.useMemo(function () {
        return (tab.config.displayCondition.visibleSections.deal.includes(changedPostSchemaItems.deal) &&
            tab.config.displayCondition.visibleSections.propertyType.includes(changedPostSchemaItems.propertyType || PostViewContentTypes_1.SECTION_TYPES.HOUSE_INFO));
    }, [changedPostSchemaItems, tab.config.displayCondition]);
    return (react_1.default.createElement(react_1.default.Fragment, null, isVisible ? (react_1.default.createElement("div", { ref: tabularTabRef, className: styles_module_scss_1.default.menu_item },
        react_1.default.createElement("li", { onClick: function () {
                handleGoalChange(tab.name);
            }, className: classnames_1.default(tab.viewed && styles_module_scss_1.default.viewed, postTabs.activeTab == tab.name && styles_module_scss_1.default.active) },
            react_1.default.createElement("span", { className: styles_module_scss_1.default.step_status }, idx + 1),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.info },
                react_1.default.createElement("span", { className: styles_module_scss_1.default.title }, tab.name === PostSectionTypes_1.POST_SECTION_TYPES.APARTMENT_INFO
                    ? t(tab.config.displayCondition
                        .headerTitles[currentPropertyData])
                    : t(tab.name))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.triangle_right })))) : (react_1.default.createElement(react_1.default.Fragment, null))));
});
exports.default = FormStepsItem;
